module.exports = __webpack_public_path__ + "img/banner-video.fbaece58.jpg";